import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1e19b0ba"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = {
  key: 0,
  class: "errormessage general"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("legend", null, "Ces informations seront affichées sur votre profil public", -1))
const _hoisted_4 = { class: "field-container" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "Companyname" }, "Nom de l'entreprise *", -1))
const _hoisted_6 = { class: "validity-icon" }
const _hoisted_7 = {
  key: 0,
  class: "errormessage"
}
const _hoisted_8 = { class: "field-container" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "Companyemail" }, "Email de l'entreprise *", -1))
const _hoisted_10 = { class: "validity-icon" }
const _hoisted_11 = {
  key: 1,
  class: "errormessage"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("legend", null, "Ces informations seront utilisées pour la facturation des projets", -1))
const _hoisted_13 = { class: "field-container" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "Companyaddress" }, "Adresse de l'entreprise *", -1))
const _hoisted_15 = { class: "validity-icon" }
const _hoisted_16 = {
  key: 0,
  class: "errormessage"
}
const _hoisted_17 = { class: "field-container" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "Siret" }, "N° de SIRET *", -1))
const _hoisted_19 = { class: "validity-icon" }
const _hoisted_20 = {
  key: 1,
  class: "errormessage"
}
const _hoisted_21 = { class: "field-container" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "TVA" }, "N° de TVA *", -1))
const _hoisted_23 = { class: "validity-icon" }
const _hoisted_24 = {
  key: 2,
  class: "errormessage"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_loader_dots = _resolveComponent("loader-dots")!

  return (_openBlock(), _createElementBlock("form", {
    id: _ctx.id,
    class: "vertical"
  }, [
    (_ctx.error != '')
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_ctx.error), 1))
      : _createCommentVNode("", true),
    _createElementVNode("fieldset", null, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("p", null, [
          _createVNode(_component_font_awesome_icon, {
            icon: _ctx.icons.companyname.use()
          }, null, 8, ["icon"])
        ]),
        _withDirectives(_createElementVNode("input", {
          id: "Companyname",
          onFocus: _cache[0] || (_cache[0] = ($event: any) => (_ctx.ClearState('companyname'))),
          onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.SubmitCompanyName && _ctx.SubmitCompanyName(...args))),
          onBlur: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.SubmitCompanyName && _ctx.SubmitCompanyName(...args))),
          type: "text",
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.companyname) = $event)),
          class: _normalizeClass({ 'valid': _ctx.formData.companyname != '' })
        }, null, 34), [
          [_vModelText, _ctx.formData.companyname]
        ]),
        _hoisted_5,
        _createElementVNode("p", _hoisted_6, [
          (_ctx.states.companyname == 'waitin')
            ? (_openBlock(), _createBlock(_component_loader_dots, {
                key: 0,
                id: "CompanynameLoaderDots",
                type: "inline"
              }))
            : (_ctx.states.companyname == _ctx.NotFoundState)
              ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                  key: 1,
                  icon: _ctx.icons.check.use()
                }, null, 8, ["icon"]))
              : (_ctx.states.companyname == _ctx.FoundState || _ctx.states.companyname == _ctx.ErrorState)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 2,
                    onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.SubmitCompanyName && _ctx.SubmitCompanyName(...args)))
                  }, [
                    _createVNode(_component_font_awesome_icon, {
                      icon: _ctx.icons.error.use()
                    }, null, 8, ["icon"]),
                    _createVNode(_component_font_awesome_icon, {
                      icon: _ctx.icons.retry.use()
                    }, null, 8, ["icon"])
                  ]))
                : _createCommentVNode("", true)
        ])
      ]),
      (_ctx.errors.companyname != '')
        ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_ctx.errors.companyname), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("p", null, [
          _createVNode(_component_font_awesome_icon, {
            icon: _ctx.icons.companyemail.use()
          }, null, 8, ["icon"])
        ]),
        _withDirectives(_createElementVNode("input", {
          id: "Companyemail",
          onFocus: _cache[5] || (_cache[5] = ($event: any) => (_ctx.ClearState('companyemail'))),
          onChange: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.SubmitEmail && _ctx.SubmitEmail(...args))),
          onBlur: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.SubmitEmail && _ctx.SubmitEmail(...args))),
          type: "email",
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formData.companyemail) = $event)),
          class: _normalizeClass({ 'valid': _ctx.formData.companyemail != '' })
        }, null, 34), [
          [_vModelText, _ctx.formData.companyemail]
        ]),
        _hoisted_9,
        _createElementVNode("p", _hoisted_10, [
          (_ctx.states.companyemail == 'waitin')
            ? (_openBlock(), _createBlock(_component_loader_dots, {
                key: 0,
                id: "CompanyemailLoaderDots",
                type: "inline"
              }))
            : (_ctx.states.companyemail == _ctx.NotFoundState)
              ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                  key: 1,
                  icon: _ctx.icons.check.use()
                }, null, 8, ["icon"]))
              : (_ctx.states.companyemail == _ctx.FoundState || _ctx.states.companyemail == _ctx.ErrorState)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 2,
                    onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.SubmitEmail && _ctx.SubmitEmail(...args)))
                  }, [
                    _createVNode(_component_font_awesome_icon, {
                      icon: _ctx.icons.error.use()
                    }, null, 8, ["icon"]),
                    _createVNode(_component_font_awesome_icon, {
                      icon: _ctx.icons.retry.use()
                    }, null, 8, ["icon"])
                  ]))
                : _createCommentVNode("", true)
        ])
      ]),
      (_ctx.errors.companyemail != '')
        ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(_ctx.errors.companyemail), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("fieldset", null, [
      _hoisted_12,
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("p", null, [
          _createVNode(_component_font_awesome_icon, {
            icon: _ctx.icons.companyaddress.use()
          }, null, 8, ["icon"])
        ]),
        _withDirectives(_createElementVNode("input", {
          id: "Companyaddress",
          onFocus: _cache[10] || (_cache[10] = ($event: any) => (_ctx.ClearState('companyaddress'))),
          onChange: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.SubmitCompanyAddress && _ctx.SubmitCompanyAddress(...args))),
          onBlur: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.SubmitCompanyAddress && _ctx.SubmitCompanyAddress(...args))),
          type: "text",
          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.formData.companyaddress) = $event)),
          class: _normalizeClass({ 'valid': _ctx.formData.companyaddress != '' })
        }, null, 34), [
          [_vModelText, _ctx.formData.companyaddress]
        ]),
        _hoisted_14,
        _createElementVNode("p", _hoisted_15, [
          (_ctx.states.companyaddress == 'waitin')
            ? (_openBlock(), _createBlock(_component_loader_dots, {
                key: 0,
                id: "CompanyaddressLoaderDots",
                type: "inline"
              }))
            : (_ctx.states.companyaddress == _ctx.NotFoundState)
              ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                  key: 1,
                  icon: _ctx.icons.check.use()
                }, null, 8, ["icon"]))
              : (_ctx.states.companyaddress == _ctx.FoundState || _ctx.states.companyaddress == _ctx.ErrorState)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 2,
                    onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.SubmitCompanyAddress && _ctx.SubmitCompanyAddress(...args)))
                  }, [
                    _createVNode(_component_font_awesome_icon, {
                      icon: _ctx.icons.error.use()
                    }, null, 8, ["icon"]),
                    _createVNode(_component_font_awesome_icon, {
                      icon: _ctx.icons.retry.use()
                    }, null, 8, ["icon"])
                  ]))
                : _createCommentVNode("", true)
        ])
      ]),
      (_ctx.errors.companyaddress != '')
        ? (_openBlock(), _createElementBlock("p", _hoisted_16, _toDisplayString(_ctx.errors.companyaddress), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("p", null, [
          _createVNode(_component_font_awesome_icon, {
            icon: _ctx.icons.siret.use()
          }, null, 8, ["icon"])
        ]),
        _withDirectives(_createElementVNode("input", {
          id: "Siret",
          onFocus: _cache[15] || (_cache[15] = ($event: any) => (_ctx.ClearState('siret'))),
          onChange: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.SubmitSIRET && _ctx.SubmitSIRET(...args))),
          onBlur: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.SubmitSIRET && _ctx.SubmitSIRET(...args))),
          type: "text",
          maxlength: "14",
          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.formData.siret) = $event)),
          class: _normalizeClass({ 'valid': _ctx.formData.siret != '' })
        }, null, 34), [
          [_vModelText, _ctx.formData.siret]
        ]),
        _hoisted_18,
        _createElementVNode("p", _hoisted_19, [
          (_ctx.states.siret == 'waitin')
            ? (_openBlock(), _createBlock(_component_loader_dots, {
                key: 0,
                id: "SiretLoaderDots",
                type: "inline"
              }))
            : (_ctx.states.siret == _ctx.NotFoundState)
              ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                  key: 1,
                  icon: _ctx.icons.check.use()
                }, null, 8, ["icon"]))
              : (_ctx.states.siret == _ctx.FoundState || _ctx.states.siret == _ctx.ErrorState)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 2,
                    onClick: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.SubmitSIRET && _ctx.SubmitSIRET(...args)))
                  }, [
                    _createVNode(_component_font_awesome_icon, {
                      icon: _ctx.icons.error.use()
                    }, null, 8, ["icon"]),
                    _createVNode(_component_font_awesome_icon, {
                      icon: _ctx.icons.retry.use()
                    }, null, 8, ["icon"])
                  ]))
                : _createCommentVNode("", true)
        ])
      ]),
      (_ctx.errors.siret != '')
        ? (_openBlock(), _createElementBlock("p", _hoisted_20, _toDisplayString(_ctx.errors.siret), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("p", null, [
          _createVNode(_component_font_awesome_icon, {
            icon: _ctx.icons.tva.use()
          }, null, 8, ["icon"])
        ]),
        _withDirectives(_createElementVNode("input", {
          id: "TVA",
          onFocus: _cache[20] || (_cache[20] = ($event: any) => (_ctx.ClearState('tva'))),
          onChange: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.SubmitTVA && _ctx.SubmitTVA(...args))),
          onBlur: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_ctx.SubmitTVA && _ctx.SubmitTVA(...args))),
          type: "text",
          maxlength: "18",
          "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.formData.tva) = $event)),
          class: _normalizeClass({ 'valid': _ctx.formData.tva != '' })
        }, null, 34), [
          [_vModelText, _ctx.formData.tva]
        ]),
        _hoisted_22,
        _createElementVNode("p", _hoisted_23, [
          (_ctx.states.tva == 'waitin')
            ? (_openBlock(), _createBlock(_component_loader_dots, {
                key: 0,
                id: "TVALoaderDots",
                type: "inline"
              }))
            : (_ctx.states.tva == _ctx.NotFoundState)
              ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                  key: 1,
                  icon: _ctx.icons.check.use()
                }, null, 8, ["icon"]))
              : (_ctx.states.tva == _ctx.FoundState || _ctx.states.tva == _ctx.ErrorState)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 2,
                    onClick: _cache[24] || (_cache[24] = 
//@ts-ignore
(...args) => (_ctx.SubmitTVA && _ctx.SubmitTVA(...args)))
                  }, [
                    _createVNode(_component_font_awesome_icon, {
                      icon: _ctx.icons.error.use()
                    }, null, 8, ["icon"]),
                    _createVNode(_component_font_awesome_icon, {
                      icon: _ctx.icons.retry.use()
                    }, null, 8, ["icon"])
                  ]))
                : _createCommentVNode("", true)
        ])
      ]),
      (_ctx.errors.tva != '')
        ? (_openBlock(), _createElementBlock("p", _hoisted_24, _toDisplayString(_ctx.errors.tva), 1))
        : _createCommentVNode("", true)
    ])
  ], 8, _hoisted_1))
}